import sust1 from '../../../assets/images/student.png';
import sust2 from '../../../assets/images/mentor.png';
import prod3 from '../../../assets/images/tutor.png';

export const productDataTwo = [
  {
    img: sust1,
    alt: 'Students',
    name: 'Be a Student',
    desc:
      'Register as a student and reap the benefits of a interactive, engaging and classroom-like online study platform.',
    
    button: 'Register👨🏻‍🎓'
  },
  {
    img: sust2,
    alt: 'mentor',
    name: 'Be a Mentor',
    desc:
      'A small light is all that one needs to travel the dark forest. Come join as a Mentor and enlighten the path of thousand wanderers.',
    button: 'Register📈'
  },
  {
    img: prod3,
    alt: 'teacher',
    name: 'Be a Tutor',
    desc:
      'Knowledge multiplies by sharing. Register yourself as a teacher and join the new generation mode of effective teaching.',
    button: 'Register👨🏽‍🏫'
  }
];
